import { translate } from '../../i18n';

/**
 * MercadoPagoLogo — Logo oficial de Mercado Pago
 * Asset de alta calidad con soporte para dispositivos Retina (@2x, @3x)
 */
const publicAsset = (path: string) => `${import.meta.env.BASE_URL}${path}`

export const MercadoPagoLogo = () => {
  const logo = publicAsset('assets/mercado-pago/mercado-pago.png')
  const logo2x = publicAsset('assets/mercado-pago/mercado-pago@2x.png')
  const logo3x = publicAsset('assets/mercado-pago/mercado-pago@3x.png')

  return (
    <img
      src={logo}
      srcSet={`${logo} 1x, ${logo2x} 2x, ${logo3x} 3x`}
      alt={translate('paymentsUI.mercadopago.title')}
      width="122.96"
      height="32"
      data-testid="mercado-pago-logo"
      style={{
        display: 'block',
        maxWidth: '100%',
        height: 'auto',
      }}
    />
  );
};
